export const tinkGrey = {
  100: '#FCFCFC',
  200: '#F9F9F9',
  300: '#F0F0F0',
  400: '#E0E0E0',
  500: '#A7A7A7',
  600: '#808080',
  700: '#494949',
  800: '#262626',
  900: '#000000',
};
